export enum LIvenessStatus {
  Completed = "COMPLETED",
  Pending = "PENDING",
  InProgress = "IN_PROGRESS",
  Error = "ERROR",
}

export enum LivenessResult {
  Valid = "VALID",
  Invalid = "INVALID",
}

export enum LivenessErrorCode {
  DocumentNotFound = "DOCUMENT_NOT_FOUND",
  InvalidDocument = "INVALID_DOCUMENT",
  NotLive = "NOT_LIVE",
  VerificationFailed = "VERIFICATION_FAILED",
  GeneralError = "GENERIC_ERROR",
  SessionTimeout = "SESSION_TIMEOUT",
  MaxAttempts = "MAX_ATTEMPTS_REACHED",
  PermissionDenied = "PERMISSION_ERROR",
}

export enum LivenessLocale {
  id = "id_ID",
  en = "en_ID",
}
